<template>
<div id="product-popup-dialog">
  <!-- 首页弹窗 -->
  <marketing-dialog
    ref="marketingDialog"
    :shows_page_type_id="3"
  ></marketing-dialog>
</div>
</template>

<script>
import MarketingDialog from '@/components/activity/dialog/marketing-dialog.vue';

export default {
  components: {
    MarketingDialog,
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {
    initPopupDialog() {
      // 营销弹窗
      this.$refs.marketingDialog.initMarketingDialog();
    },
  },
};
</script>

<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/pages/product/product-info/components/product-popup-dialog.vue